/* eslint-disable react-hooks/exhaustive-deps */
import "./styles.css";
import { CircularProgress, Grid, Link } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect } from "react";
import { useFormik } from "formik";
import { getValidationSchema } from "../../../../shared/validations/schema";
import { setLocalStorageData } from "../../../../shared/utils/localStorage";
import InputTextfield from "../../../../shared/components/textField";
import { useNavigate } from "react-router-dom";
import useMutation from "../../../../shared/components/hooks/useMutation";
// import LoginImg from "../../../../assets/img/login.svg";
// import LoginBg from "../../../../assets/img/login-bg.svg";

const Login = (props: any) => {
  // const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { loading, modifyData } = useMutation();

  // const snackBarAlertContext = useContext(SnackBarAlertContext);
  const isAuthenticated = localStorage.getItem("token");

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const textFields = [
    {
      id: "login-username",
      name: "email",
      label: "Email",
      placeholder: "Enter your email",
      type: "text",
      required: true,
    },
    {
      id: "login-password",
      name: "password",
      label: "Password",
      placeholder: "Enter your password",
      type: "password",
      required: true,
    },
  ];

  const loginForm = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: getValidationSchema(["email", "password"]),
    onSubmit: async (loginData: any) => {
      const response = await modifyData(`/auth/login`, "post", loginData);
      if (response) {
        setLocalStorageData("userData", response?.data);
        navigate("/dashboard", { replace: true });
      }

      // fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(loginData),
      // })
      // .then(async (response) => {
      //   if (!response.ok) {
      //     const errorData = await response.json(); // Get error message from API
      //     throw new Error(
      //       errorData?.message ||
      //         `Error ${response.status}: ${response.statusText}`
      //     );
      //   }
      //   console.log("response ::::::::::", response);
      //   const responseType = response.headers.get("Content-Type");
      //   // setLocalStorageData("global_token", response.headers.get("token"));
      //   setLocalStorageData("token", response.headers.get("token"));

      //   if (responseType === "image/png") {
      //     return response.blob().then((blob) => {
      //       const url = URL.createObjectURL(blob);
      //       props.setQrCodeSrc(url);
      //     });
      //   } else {
      //     const data = await response.json();
      //     setLoading(false);

      //     if (data.message === "Login successful") {
      //       setLocalStorageData("userData", data?.data);
      //       navigate("/dashboard");
      //     } else if (data.errors) {
      //       snackBarAlertContext.set({
      //         status: true,
      //         type: "error",
      //         message: data?.message,
      //       });
      //     }
      //   }
      // })
      //   .catch((error) => {
      //     console.error("Fetch Error:", error);
      //     setLoading(false);

      //     snackBarAlertContext.set({
      //       status: true,
      //       type: "error",
      //       message: error.message || "Something went wrong. Please try again.",
      //     });
      //   });
    },
  });
  return (
    <div className="loginGrid">
      <form
        onSubmit={loginForm.handleSubmit}
        autoComplete="off"
        // className="loginForm"
      >
        {textFields.map((field: any, index: number) => (
          <InputTextfield
            key={index}
            className="mediumInputBox"
            form={loginForm}
            fieldProps={field}
          />
        ))}
        <Grid container justifyContent="flex-end">
          <Link href="/forgot-password" className="forgotPassword" sx={{color: "#25353D !important"}}>
            Forgot password?
          </Link>
        </Grid>

        <Grid container justifyContent="center" style={{ marginTop: "20px" }}>
          <Grid item xs={12}>
            <LoadingButton
              className="signInButton"
              loading={loading}
              loadingIndicator={
                <CircularProgress size={22} sx={{ color: "white" }} />
              }
              variant="contained"
              type="submit"
              fullWidth
              size="large"
            >
              <span style={{ visibility: loading ? "hidden" : "visible" }}>
                Sign in
              </span>
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </div>

    // <>
    //   {/* <img className="login-bg" src={LoginBg} alt="" /> */}
    //   <Grid container justifyContent="flex-end">
    //     {" "}
    //     <Grid item md={5} className="loginGridWrapper">
    //       {/* <img src={LoginImg} className="login-img" alt="" /> */}
    //       <div className="leftCircle"></div>

    //       <div className="loginGridContainer">
    //         <form
    //           onSubmit={loginForm.handleSubmit}
    //           autoComplete="off"
    //           className="loginForm"
    //         >
    //           {textFields.map((field: any, index: number) => {
    //             return (
    //               <InputTextfield
    //                 className="mediumInputBox"
    //                 form={loginForm}
    //                 fieldProps={field}
    //                 key={index}
    //               />
    //             );
    //           })}
    //           <Grid container>
    //             <Grid item md={12}>
    //               <Link href="/forgot-password" className="forgotPassword">
    //                 Forgot password?
    //               </Link>
    //             </Grid>
    //           </Grid>
    //           <Grid container justifyContent="flex-end">
    //             <Grid item md={4}>
    //               <LoadingButton
    //                 className="signInButton"
    //                 loading={loading}
    //                 variant="contained"
    //                 type="submit"
    //                 fullWidth
    //                 size="small"
    //               >
    //                 Login
    //               </LoadingButton>
    //             </Grid>
    //           </Grid>
    //         </form>
    //       </div>
    //       {/* <div className="rightCircle"></div> */}
    //     </Grid>
    //     {/* <Grid item md={0.85}></Grid> */}
    //   </Grid>
    // </>
  );
};

export default Login;
